export const SellPartnersConfig = {
  1: [ //US Store
    {
      src: "/w_300,c_scale/sell/partners/mlb_primary_logo.png",
      alt: "Major League Baseball",
      type: "mlb"
    },
    {
      src: "/w_300,c_scale/sell/partners/rtc_hq_logo.png",
      alt: "Roundabout Theatre Company",
      type: "wide"
    },
    {
      src: "/w_300,c_scale/sell/partners/FF_Logo.png",
      alt: "Firefly Music Festival",
      type: "wide"
    },
    {
      src: "/w_300,c_scale/sell/partners/philadelphia76ers_logo.png",
      alt: "Philidelphia 76ers",
      type: "square"
    },
    {
      src: "/w_300,c_scale/sell/partners/hangout_fest_logo.png",
      alt: "Hangout Music Festival",
      type: "wide"
    },
    {
      src: "/w_300,c_scale/sell/partners/New_York_City_FC.png",
      alt: "New York City Football Club",
      type: "square"
    },
    {
      src: "/w_300,c_scale/sell/partners/Crest_Logo_Color.png",
      alt: "Buffalo Sabres",
      type: "square"
    },
    {
      src: "/w_300,c_scale/sell/partners/Pelicans_logo.png",
      alt: "New Orleans Pelicans",
      type: "square"
    },
    {
      src: "/w_300,c_scale/sell/partners/WWE_Logo_Rendered_Busy_Background.png",
      alt: "World Wrestling Entertainment",
      type: "square"
    },
    {
      src: "/w_300,c_scale/sell/partners/MichiganWolverines_logo.png",
      alt: "University of Michigan",
      type: "square"
    }
  ]
};
